import React from 'react'
import cx from 'classnames'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Form } from 'components/shared/Form/Form'
// import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'

import { fetchInterviewTemplates } from 'api/interviewTemplates'
import {
  ABILITY_TEST_FIELD,
  INTERVIEW_TEMPLATE_FIELD,
  INTERVIEW_MOUDLE_FIELD,
  MODULES_FIELD,
  PERSONALITY_TEST_FIELD,
  getContent,
} from './model'

import styles from './Modules.module.scss'

export const Modules = ({
  control,
  formState,
  setValue,
  watch,
  hasInverviewModuleDisabled,
  isEditMode,
  showTemplates,
  setShowTemplates,
}) => {
  const content = getContent()

  const interviewValue = watch(`${MODULES_FIELD}[2].${INTERVIEW_MOUDLE_FIELD}`)
  const template = watch(INTERVIEW_TEMPLATE_FIELD)

  const department = control._formValues?.department
  const departmentId = department?.value

  const resultsMatcher = ({ title }) => ({ label: title, value: title })

  React.useEffect(() => {
    if (!interviewValue && template) {
      setValue(INTERVIEW_TEMPLATE_FIELD, null)
    }
  })

  const getInterviewTemplates = query =>
    fetchInterviewTemplates({
      ...query,
      department: departmentId,
    })

  return (
    <Box className={styles.modules} direction="column">
      {/* TODO: unlock when all modules are selectable */}
      {/* <MessageAlert
        className={styles.alert}
        message={t`At least one module must be selected.`}
        variant={isFormDataInvalid ? 'error' : 'info'}
        isInitialised={isFormDataInvalid}
      /> */}
      <Box align="center" direction="column">
        <Box direction="column">
          <Form.Field
            className={styles.field}
            field="checkbox"
            hint={
              hasInverviewModuleDisabled
                ? t`Interview module cannot be removed if there are candidates eligible for interviews or later stages.`
                : null
            }
            hintVariant="info"
            label={content[INTERVIEW_MOUDLE_FIELD].label}
            labelClassName={styles.label}
            labelSize="medium"
            name={`${MODULES_FIELD}[2].${INTERVIEW_MOUDLE_FIELD}`}
            isDisabled={
              hasInverviewModuleDisabled ||
              content[INTERVIEW_MOUDLE_FIELD].isDisabled
            }
            {...{ control }}
          />
          <p
            className={cx(styles.description, {
              [styles.disabled]: content[INTERVIEW_MOUDLE_FIELD].isDisabled,
              [styles.interviewDescription]: interviewValue,
            })}
          >
            {content[INTERVIEW_MOUDLE_FIELD].description}
          </p>

          {interviewValue ? (
            <p className={cx(styles.description)}>
              {t`By default, the interview template created for this job will copy the competencies from the Competencies tab. Alternatively, you can`}{' '}
              <span
                onClick={() => setShowTemplates(true)}
                className={cx(styles.inlineButton)}
              >
                {t`choose an existing template`}.
              </span>
            </p>
          ) : null}
        </Box>
        {interviewValue && showTemplates ? (
          <Box className={styles.interview} direction="column">
            <Form.Field
              className={styles.template}
              error={formState.errors[INTERVIEW_TEMPLATE_FIELD]?.message}
              field="combobox"
              hint={
                hasInverviewModuleDisabled
                  ? t`Changing the interview template may affect the ability to fairly compare candidates.\nPlease make only necessary adjustments to maintain consistency in the evaluation process.`
                  : !departmentId
                    ? t`Select department in Details tab in order to see templates associated with that department.`
                    : null
              }
              hintVariant="warning"
              label={t`Select interview template`}
              noOptionsMessage={t`No templates in selected department`}
              labelClassName={styles.label}
              name={INTERVIEW_TEMPLATE_FIELD}
              fetchOptions={[getInterviewTemplates, resultsMatcher]}
              isClearable
              isSearchable
              isDisabled={!departmentId}
              {...{ control }}
            />
            {/*!isEditMode ? (
              <p className={styles.hint}>
                {t`or\nyou can select or change template later, editing job details`}
              </p>
            ) : null*/}
          </Box>
        ) : null}
        <Box direction="column">
          <Form.Field
            className={styles.field}
            field="checkbox"
            label={content[ABILITY_TEST_FIELD].label}
            labelSize="medium"
            name={`${MODULES_FIELD}[0].${ABILITY_TEST_FIELD}`}
            isDisabled={content[ABILITY_TEST_FIELD].isDisabled}
            {...{ control }}
          />
          <p
            className={cx(styles.description, {
              [styles.disabled]: content[ABILITY_TEST_FIELD].isDisabled,
            })}
          >
            {content[ABILITY_TEST_FIELD].description}
          </p>
        </Box>
        <Box direction="column">
          <Form.Field
            className={styles.field}
            field="checkbox"
            label={content[PERSONALITY_TEST_FIELD].label}
            labelSize="medium"
            name={`${MODULES_FIELD}[1].${PERSONALITY_TEST_FIELD}`}
            isDisabled={content[PERSONALITY_TEST_FIELD].isDisabled}
            {...{ control }}
          />
          <p
            className={cx(styles.description, {
              [styles.disabled]: content[PERSONALITY_TEST_FIELD].isDisabled,
            })}
          >
            {content[PERSONALITY_TEST_FIELD].description}
          </p>
        </Box>
      </Box>
    </Box>
  )
}
